import { LocationMapper } from "app/location/location.mapper";
import { LocationGroup } from "./location-group.model";

export class LocationGroupMapper {
  public static map(data: any): LocationGroup {
    if (!data) {
      return null;
    }

    return new LocationGroup(
      data.id,
      data.name,
      data.availableOnline,
      data.locations
        ? data.locations.map((location) => LocationMapper.map(location))
        : null,
      data.countries,
      data.kind,
    );
  }
}
